/* eslint-disable */
import { useCookies } from 'react-cookie';
import { useDataContext } from '../context';
import React, { useEffect, useState, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';

// ประกาศตัวแปรรับค่าจาก env
const API_URL = import.meta.env.VITE_API_URL;

function TechnicianService() {
  const { data, setData } = useDataContext();
  const [cookies, setCookie] = useCookies(['session']);
  console.log("🚀 ~ TechnicianService ~ cookies:", cookies)
  const [name, setName] = useState(null);
  console.log("🚀 ~ TechnicianService ~ name:", name)

  useEffect(() => {
    if (cookies.session && data?.getAllEmployees) {
      try {
        const decodedToken = jwtDecode(cookies.session);
        const foundEmployee = data.getAllEmployees.find(
          (employee) =>
               (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
            (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
            (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
            (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
        );

        if (foundEmployee) {
          setName((prev) =>
            prev?.employeeCode !== foundEmployee.employeeCode ? foundEmployee : prev
          );
        }
      } catch (error) {
        console.error('Decode token error:', error);
      }
    }
  }, [cookies.session, data?.getAllEmployees]);
  // ป้องกันการยิงซ้ำ
  const hasFetched = useRef(false);

  // ฟังก์ชันสำหรับ assign พนักงานให้เป็นช่าง
  const assignTechnician = async (employeeId, technicianData) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      if (cookies.token) {
        myHeaders.append("Authorization", `Bearer ${cookies.token}`);
      }

      const raw = JSON.stringify({
        employeeId: employeeId,
        isTechnician: "1", // ส่งเป็น string เสมอ
        technicianSpecialization: technicianData.specialization || '',
        technicianCertification: technicianData.certification || '',
        technicianYearsOfExperience: technicianData.experience || 0,
        technicianSkills: JSON.stringify(technicianData.skills || []),
        technicianAssignedBy: name?.nameTh || 'System',
        technicianAssignedDate: new Date().toISOString(),
        technicianReason: technicianData.reason || 'Manual assignment'
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      const response = await fetch(`${API_URL}/assignTechnician`, requestOptions);
      const result = await response.json();
      
      console.log('assignTechnician API response:', result);
      
      if (result.status === 'success') {
        // อัปเดตข้อมูลใน context
        setData(prevData => ({
          ...prevData,
          alert: true,
          alertIcon: 'success',
          alertText: 'กำหนดสิทธิช่างเรียบร้อย',
          alertTitle: 'สำเร็จ',
        }));
        
        // รีเฟรช employee data
        await refreshEmployeeData();
      } else {
        // แสดง error message ตามที่ API ส่งมา
        const errorMessage = result.message || result.error || 'Failed to assign technician';
        
        // ถ้าเป็น error "already assigned" ให้ refresh ข้อมูลเผื่อว่าข้อมูลใน frontend ไม่ตรงกับ backend
        if (errorMessage.toLowerCase().includes('already assigned')) {
          console.log('Employee already assigned, refreshing data...');
          await refreshEmployeeData();
          
          setData(prevData => ({
            ...prevData,
            alert: true,
            alertIcon: 'warning',
            alertText: 'พนักงานคนนี้เป็นช่างอยู่แล้ว ระบบได้อัปเดตข้อมูลให้แล้ว',
            alertTitle: 'แจ้งเตือน',
          }));
        } else {
          setData(prevData => ({
            ...prevData,
            alert: true,
            alertIcon: 'error',
            alertText: errorMessage,
            alertTitle: 'เกิดข้อผิดพลาด',
          }));
        }
        
        throw new Error(errorMessage);
      }
      
      return result;
    } catch (error) {
      console.error('Error assigning technician:', error);
      setData(prevData => ({
        ...prevData,
        alert: true,
        alertIcon: 'error',
        alertText: 'ไม่สามารถกำหนดสิทธิช่างได้',
        alertTitle: 'เกิดข้อผิดพลาด',
      }));
      throw error;
    }
  };

  // ฟังก์ชันสำหรับ unassign สถานะช่าง
  const unassignTechnician = async (employeeId, reason = '') => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      if (cookies.token) {
        myHeaders.append("Authorization", `Bearer ${cookies.token}`);
      }

      const raw = JSON.stringify({
        employeeId: employeeId,
        isTechnician: "0", // ส่งเป็น string เสมอ
        technicianUnassignedBy: data?.currentUser?.employeeCode || 'System',
        technicianUnassignedDate: new Date().toISOString(),
        technicianReason: reason || 'Manual unassignment'
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      const response = await fetch(`${API_URL}/unassignTechnician`, requestOptions);
      const result = await response.json();
      
      if (result.status === 'success') {
        // อัปเดตข้อมูลใน context
        setData(prevData => ({
          ...prevData,
          alert: true,
          alertIcon: 'success',
          alertText: 'ยกเลิกสิทธิช่างเรียบร้อย',
          alertTitle: 'สำเร็จ',
        }));
        
        // รีเฟรช employee data
        await refreshEmployeeData();
      } else {
        throw new Error(result.message || 'Failed to unassign technician');
      }
      
      return result;
    } catch (error) {
      console.error('Error unassigning technician:', error);
      setData(prevData => ({
        ...prevData,
        alert: true,
        alertIcon: 'error',
        alertText: 'ไม่สามารถยกเลิกสิทธิช่างได้',
        alertTitle: 'เกิดข้อผิดพลาด',
      }));
      throw error;
    }
  };

  // ฟังก์ชันสำหรับ refresh ข้อมูล employee
  const refreshEmployeeData = async () => {
    try {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
      };

      const response = await fetch(`${API_URL}/getAllEmployees`, requestOptions);
      const result = await response.json();
      
      if (result.data) {
        setData(prevData => ({
          ...prevData,
          getAllEmployees: result.data
        }));
      }
    } catch (error) {
      console.error('Error refreshing employee data:', error);
    }
  };

  // Auto-load เมื่อ component mount (ไม่จำเป็นแล้วเพราะข้อมูลอยู่ใน getAllEmployees)
  useEffect(() => {
    // ไม่ต้อง load ข้อมูลเพิ่มเติมเพราะข้อมูลช่างอยู่ใน employee record แล้ว
    hasFetched.current = true;
  }, []);

  // Return ฟังก์ชันต่างๆ เพื่อให้ component อื่นใช้งาน
  return {
    assignTechnician,
    unassignTechnician,
    refreshEmployeeData
  };
}

export default TechnicianService;